import { QuizEnvelop } from './../../_models/quizEnvelop';
import { Subscription } from './../../_models/subscription';
import { QuizService } from './../../_services/quiz.service';
import { StudentService } from 'src/app/_services/student.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './../../_services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Student } from 'src/app/_models/student';

@Component({
  selector: 'app-admin-show-quiz',
  templateUrl: './admin-show-quiz.component.html',
  styleUrls: ['./admin-show-quiz.component.css']
})
export class AdminShowQuizComponent implements OnInit {
  public quizEnvelop= new QuizEnvelop()
  student= new Student()
  learner:any={}
  subscription = new Subscription()
  subscriptionId=0
  isPremium=false
  studentUserId=0
  loading=true
  renderMathNow=false
  renderCount=0
  questionCount=0

  mageSource:any
  downloading=false

  constructor(
    public authService:AuthService,
    private route: ActivatedRoute,
    private router:Router,
    private quizService:QuizService
  ){}

  ngOnInit(): void {

    this.route.params.subscribe(
      p=>{
        let quizEnvelopId = p['server_quiz_envelop_id']
        if(quizEnvelopId!=0){
          this.quizService.getQuizEnvelop(quizEnvelopId).subscribe(
            x=>{
              this.quizEnvelop=x
              this.questionCount=this.quizEnvelop['questions'].length
              this.loading=false
             })
            }
          })
        }

  renderMathPage(value:boolean){
  this.renderCount+=1
  if(this.renderCount == this.questionCount){
    this.renderMathNow=true
  }
}

deleteQuizEnvelop(){
  this.loading=true
  this.quizService.deleteQuiz(this.quizEnvelop.server_quiz_envelop_id).subscribe(
    xx=>{
      this.loading=false
      this.router.navigate(['/admin/envelop/quiz/index'])

    }
  )
}
}
